import axiosWithMjrAccessToken from 'utils/axiosWithMjrAccessToken';
import { logError } from 'utils/errorLogger';

/**
 * editInfo
 *
 * @param user - data from form or user object
 *
 * Takes user form/data object and updates customer information
 */
export const editUser = async (user) => {
  let updateSuccess = false;
  user.phone = user.phone.replace(/\D/g, '');
  // call update customer
  await axiosWithMjrAccessToken
    .put(`${process.env.NEXT_PUBLIC_PROXY_MJR_API_URL}/api/Customer/Update`, user)
    .then((res) => {
      updateSuccess = res;
    })
    .catch((error) => {
      logError(error, 'editUser - /utils/editUser.js');
      updateSuccess = error.response;
    });

  return updateSuccess;
};
